<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 600px; background-image: url(/img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-dark opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">

                        <h1 class="display-2 text-white">Hi There {{namer}}</h1>
                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">My account</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>

                                <div class="pl-lg-4">
                                    <h3>Update Your Email</h3>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Email"
                                                        placeholder="Username"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.email"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Current Password"
                                                        type="password"
                                                        placeholder="Current Password"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.password"
                                            />
                                        </div>
                                    </div>
                                    <base-button @click="handleUpdateEmail" class="btn btn-dark">Update Email</base-button>
                                    <hr>
                                    <h3>Update Your Password</h3>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Current Password"
                                                        type="password"
                                                        placeholder="Current Password"
                                                        input-classes="form-control-alternative"
                                                        v-model="passwordModel.currentPassword"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Password"
                                                        placeholder="Your Password Here"
                                                        type="password"
                                                        input-classes="form-control-alternative"
                                                        v-model="passwordModel.newPassword"
                                            />
                                        </div>

                                    </div>
                                    <base-button @click="handleUpdatePassword" class="btn btn-dark">Update Password</base-button>

                                </div>


                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import NProgress from 'nprogress'
  export default {
    name: 'user-profile',
    data() {
      return {
        model: {
          email: localStorage.uberEmail,
          password: '',
        },
        passwordModel: {
          currentPassword: '',
          newPassword: '',
        },
      }
    },
    computed: {
      namer() {
        return localStorage.uberName
      },
    },
    methods: {
      handleUpdateEmail () {
        console.log(JSON.stringify(this.model))
        const innerModel = {
          email: localStorage.uberEmail,
          password: this.model.password,
        };
        const bodyTosend = {
          email: this.model.email,
        };

        this.$store
        .dispatch("user/login", innerModel).then(() => {
          // then just make an update user api call
          console.log("yessss");
          console.log(bodyTosend);
          this.$store.dispatch("user/update", bodyTosend)
          .then(() => {
            console.log("Successfull");
            alert("Your Email Has Been Successfully Changed. We are redirecting you so you can login again.")
            window.location.href = "/login"
          })
          .catch(() => {
            console.log("failed");
            NProgress.done();
          })

        }).catch(() => {
          console.log("Naa shit password");
          alert('Wrong Email Password Combination. Please Check And Try Again');
          NProgress.done();
        });

      },

      handleUpdatePassword(){

        const notEmpty = this.passwordModel.currentPassword !== '' && this.passwordModel.newPassword !== '';

        if (!notEmpty) {
          return alert("Please Fill The Box For Current And New Password Before Hitting The Button")
        }

        console.log(JSON.stringify(this.model))
        const innerModel = {
          email: localStorage.uberEmail,
          password: this.passwordModel.currentPassword,
        };
        const bodyTosend = {
          password: this.passwordModel.newPassword,
        };

        this.$store
        .dispatch("user/login", innerModel).then(() => {
          // then just make an update user api call
          console.log("yessss");
          console.log(bodyTosend);
          this.$store.dispatch("user/update", bodyTosend)
          .then(() => {
            console.log("Successfull");
            alert("Your Password Has Been Successfully Changed. We are redirecting you so you can login again.")
            window.location.href = "/login"
          })
          .catch(() => {
            console.log("failed");
            NProgress.done();
          })

        }).catch(() => {
          console.log("Naa shit password");
          alert('Wrong Current Password Please Check And Try Again');
          NProgress.done();
        });

      },
    },
  };
</script>
<style></style>
